/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import Dashboard from '@material-ui/icons/Dashboard'
import InsertChart from '@material-ui/icons/InsertChart'
import CategoryIcon from '@material-ui/icons/Category'
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasketOutlined'
import BusinessIcon from '@material-ui/icons/Business'
import AppsIcon from '@material-ui/icons/Apps'
import PeopleIcon from '@material-ui/icons/People'

// core components/views for Admin layout
import DashboardPage from './views/Dashboard/Dashboard.js'
import Reports from './views/Reports/Reports.js'
import Categories from './views/Categories/Categories.js'
import BackOfficeSelector from './views/BackOfficeSelector/BackOfficeSelector.js'
import HotkeyEditor from './views/HotkeyEditor/HotkeyEditor.js'
import UserManagement from './views/UserManagement/UserManagement.js'
import ProductsWrapperPage from './views/ProductsWrapper/ProductsWrapper.js'

// important to make sure any extra options added are 8, 16, 32 etc so bit masking works
const RouteDisplay = {
  Hyperion: 1,
  ShopMate: 2,
  Atlas: 4
}

const dashboardRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: Dashboard,
    component: DashboardPage,
    layout: '/app',
    display: RouteDisplay.Hyperion | RouteDisplay.ShopMate | RouteDisplay.Atlas
  },
  {
    path: '/reports',
    name: 'Reports',
    icon: InsertChart,
    component: Reports,
    layout: '/app',
    display: RouteDisplay.Hyperion | RouteDisplay.ShopMate | RouteDisplay.Atlas
  },
  {
    path: '/products',
    name: 'Products',
    icon: ShoppingBasketIcon,
    component: ProductsWrapperPage,
    layout: '/app',
    display: RouteDisplay.Hyperion | RouteDisplay.ShopMate | RouteDisplay.Atlas
  },
  {
    path: '/categories',
    name: 'Categories',
    icon: CategoryIcon,
    component: Categories,
    layout: '/app',
    display: RouteDisplay.Hyperion
  },
  {
    path: '/backoffice',
    name: 'BackOffice',
    icon: BusinessIcon,
    component: BackOfficeSelector,
    layout: '/app',
    display: RouteDisplay.ShopMate
  },
  {
    path: '/hotkey_editor',
    name: 'Hotkey Editor',
    icon: AppsIcon,
    component: HotkeyEditor,
    layout: '/app',
    display: RouteDisplay.Hyperion
  },
  {
    path: '/user_management',
    name: 'User Management',
    icon: PeopleIcon,
    component: UserManagement,
    layout: '/app',
    display: RouteDisplay.Hyperion
  }
]

export {
  dashboardRoutes as routes,
  RouteDisplay
}
